import axios from "axios";
import { useContext, useEffect, useState } from "react";
import "./style.css";
import { ArrowLeft, ArrowRight, Clock } from "iconsax-react";
import {
	MDBBtn,
	MDBIcon,
	MDBModal,
	MDBModalBody,
	MDBModalContent,
	MDBModalDialog,
	MDBModalFooter,
	MDBProgress,
	MDBProgressBar,
	MDBSpinner,
} from "mdb-react-ui-kit";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import mbtiLogo from "../../assets/images/mbti-logo 1.png";
import { api } from "../../utils/axios";
import { JWTContext } from "../../utils/context/JWTContext";
import { UserContext } from "../../utils/context/userContext";

function MBTIForm() {
	const [questions, setQuestions] = useState([]);
	const [answers, setAnswers] = useState({});
	const [result, setResult] = useState(null);
	const [basicModal, setBasicModal] = useState(true);
	const [stage, setStage] = useState(null);
	const navigate = useNavigate();
	// const { setJWT } = useContext(JWTContext)
	// const {userDetail} =useContext(UserContext)
	const toggleOpen = () => setBasicModal(!basicModal);
	const userData = useSelector((state) => state.user.data);
	const { jwt, setJWT } = useContext(JWTContext);

	useEffect(() => {
		api
			.get("/questions")
			.then((response) => {
				setQuestions(response.data);
			})
			.catch((error) => {
				// Error handling
			});
	}, []);

	const handleOptionChange = (questionId, dimension, value) => {
		setAnswers({
			...answers,
			[questionId]: { dimension, value },
		});
	};

	const handleSubmit = () => {
		if (Object.keys(answers).length !== questions.length) {
			toast.error("لطفاً به همه سوالات پاسخ دهید.");
			return;
		}

		const answerList = Object.entries(answers).map(([questionId, answer]) => ({
			question_id: questionId,
			dimension: answer.dimension,
			value: answer.value,
		}));

		if (!userData || !userData.user || !userData.user.uid) {
			toast.error("اطلاعات کاربر موجود نیست.");
			return;
		}

		api
			.post(
				"/submit",
				{ answers: answerList },
				{
					headers: {
						Authorization: `Bearer ${localStorage.getItem("token")}`,
					},
				},
			)
			.then((response) => {
				setResult(response.data);
				setBasicModal(true);
				toast.success("فرم با موفقیت ارسال شد.");
			})
			.catch((err) => {
				toast.error("خطا در ارسال فرم.");
			});
	};
	function changeStage(move) {
		switch (move) {
			case "next":
				//next stage
				if (stage < 39 && answers[stage + 1]) setStage(stage + 1);
				break;
			case "prev":
				//prev stage
				if (stage > 0) setStage(stage - 1);
		}
	}

	// Color mapping for MBTI types
	const mbtiColors = {
		ENTP: { main: "#7C5DC5", light: "#E9D8FD" },
		ISTP: { main: "#F5B000", light: "#FFF6D6" },
		INFJ: { main: "#1B9E77", light: "#D6F5EC" },
		ESTJ: { main: "#3C9C99", light: "#D6F5F2" },
	};
	// Get color for current type (default to ENTP if not found)
	const typeKey =
		result && result.mbti_type ? result.mbti_type.toUpperCase() : "ENTP";
	const typeColor = mbtiColors[typeKey] || mbtiColors.ENTP;

	if (!questions.length) {
		return (
			<div
				className="d-flex justify-content-center align-items-center w-100 "
				style={{ height: "100vh" }}
			>
				<MDBSpinner color="primary" size="lg">
					<span className="visually-hidden">Loading...</span>
				</MDBSpinner>
			</div>
		);
	}

	return (
		<div
			className="bg-white  overflow-auto d-flex flex-column p-md-5 vazir h-100 w-100  py-[24px] px-[77px] justify-content-center align-items-center"
			style={{ borderRadius: "15px" }}
		>
			{result ? (
				<div className="mbti-result-container">
					<div className="mbti-result-title">
						<div className="mbti-result-type">
							تیپ شخصیتی شما:{" "}
							<span className="mbti-result-type-en">{result.mbti_type}</span>
							{result.mbti_name && (
								<span className="mbti-result-type-name">
									{" "}
									({result.mbti_name})
								</span>
							)}
						</div>
						<div className="mbti-result-traits">
							{/* Compose the four traits in order, e.g. برون‌گرا - شهودی - منطقی - ادراکی */}
							{(() => {
								if (result.traits && result.traits.length === 4) {
									return result.traits.join(" - ");
								}
								// Fallback: generate from mbti_type
								const traitMap = {
									E: "برون‌گرا",
									I: "درون‌گرا",
									S: "حسی",
									N: "شهودی",
									T: "منطقی",
									F: "احساسی",
									J: "قضاوت‌کننده",
									P: "اکتشاف‌کننده",
								};
								if (result.mbti_type && result.mbti_type.length === 4) {
									return [
										traitMap[result.mbti_type[0]],
										traitMap[result.mbti_type[1]],
										traitMap[result.mbti_type[2]],
										traitMap[result.mbti_type[3]],
									].join(" - ");
								}
								return "";
							})()}
						</div>
					</div>
					<div className="mbti-result-layout">
						<div className="mbti-bars-col">
							{(() => {
								const mbtiPairs = [
									{
										left: { label: "درونگرا(I)", code: "I" },
										right: { label: "برونگرا(E)", code: "E" },
										title: "نحوه تعامل با محیط اطراف",
									},
									{
										left: { label: "شهودی(N)", code: "N" },
										right: { label: "حسی(S)", code: "S" },
										title: "عامل هدایت انرژی ذهنی",
									},
									{
										left: { label: "احساسی(F)", code: "F" },
										right: { label: "منطقی(T)", code: "T" },
										title: "نحوه تصمیم گیری و واکنش به احساسات",
									},
									{
										left: { label: "قضاوت کننده(J)", code: "J" },
										right: { label: "اکتشاف کننده(P)", code: "P" },
										title: "رویکرد شخصی در کار و برنامه‌ریزی",
									},
								];
								return mbtiPairs.map((pair, idx) => {
									const leftVal = result.percentages[pair.left.code] || 0;
									const rightVal = result.percentages[pair.right.code] || 0;
									const leftBold = leftVal > rightVal;
									const rightBold = rightVal > leftVal;
									// Dynamic bar color
									const barColor = typeColor.main;
									const barLight = typeColor.light;
									return (
										<div
											key={pair.left.code + pair.right.code}
											className="mbti-pair-container"
											style={{ borderColor: barColor }}
										>
											<div className="mbti-pair-title">{pair.title}</div>
											<div
												className="mbti-pair-bar-row"
												style={{ borderColor: barColor }}
											>
												<div
													className={`mbti-pair-half mbti-pair-half-left ${leftBold ? "mbti-pair-half-bg" : "mbti-pair-half-white"}`}
													style={
														leftBold
															? { background: barColor }
															: { background: "transparent" }
													}
												>
													<div
														className={`mbti-pair-circle mbti-pair-circle-left${leftBold ? " mbti-pair-circle-bold" : ""}`}
														style={
															leftBold
																? {
																		background: "#fff",
																		color: barColor,
																		borderColor: barColor,
																	}
																: {
																		background: barLight,
																		color: barColor,
																		borderColor: barColor,
																	}
														}
													>
														<div className="mbti-pair-percent">
															{leftVal.toFixed(0)}%
														</div>
													</div>
													<div
														className={`mbti-pair-label mbti-pair-label-left${leftBold ? " mbti-pair-label-bold" : ""}`}
														style={
															leftBold ? { color: "#fff" } : { color: barColor }
														}
													>
														{pair.left.label}
													</div>
												</div>
												<div
													className={`mbti-pair-half mbti-pair-half-right ${rightBold ? "mbti-pair-half-bg" : "mbti-pair-half-white"}`}
													style={
														rightBold
															? { background: barColor }
															: { background: "transparent" }
													}
												>
													<div
														className={`mbti-pair-label mbti-pair-label-right${rightBold ? " mbti-pair-label-bold" : ""}`}
														style={
															rightBold
																? { color: "#fff" }
																: { color: barColor }
														}
													>
														{pair.right.label}
													</div>
													<div
														className={`mbti-pair-circle mbti-pair-circle-right${rightBold ? " mbti-pair-circle-bold" : ""}`}
														style={
															rightBold
																? {
																		background: "#fff",
																		color: barColor,
																		borderColor: barColor,
																	}
																: {
																		background: barLight,
																		color: barColor,
																		borderColor: barColor,
																	}
														}
													>
														<div className="mbti-pair-percent">
															{rightVal.toFixed(0)}%
														</div>
													</div>
												</div>
											</div>
										</div>
									);
								});
							})()}
						</div>
						<div
							className="mbti-summary-box"
							style={{ background: typeColor.light, color: typeColor.main }}
						>
							<div className="mbti-summary-title">
								توصیف {result.mbti_type}:
							</div>
							<div className="mbti-summary-desc">
								{result.content?.split("\n").filter(Boolean)[1] || ""}
							</div>
							<div className="mbti-summary-quote-title">
								جمله افراد {result.mbti_type}:
							</div>
							<div
								className="mbti-summary-quote"
								style={{ color: typeColor.main }}
							>
								<span
									className="mbti-quote-icon"
									style={{ color: typeColor.main }}
								>
									❞
								</span>
								{result.content?.split("\n").filter(Boolean)[2] || ""}
							</div>
						</div>
					</div>
					{/* MBTI Type Explanation Section */}
					<div className="mbti-type-explanation">
						{result.mbti_summary
							? result.mbti_summary
							: result.content &&
								result.content
									.split("\n")
									.filter(Boolean)
									.slice(3, 7)
									.reverse()
									.map((p, i) => <p key={i}>{p}</p>)}
					</div>
				</div>
			) : stage !== null ? (
				<>
					<div className="bg-light container d-flex flex-column p-md-5 vazir h-100 w-100 justify-content-center align-items-center">
						<div className="w-100 d-flex justify-content-center align-items-center">
							<h1>تست MBTI (مایرز بریگز)</h1>
						</div>
						<div
							className="bg-white  d-flex flex-column p-md-5 vazir h-100 w-100 justify-content-center align-items-start align-items-md-center"
							style={{ borderRadius: "15px" }}
						>
							<div
								key={questions[stage].id}
								className="question-block w-100 h-fit d-flex justify-content-start align-items-center flex-column"
							>
								<div
									className="w-100 h-auto d-flex flex-column gap-2"
									style={{ marginTop: 50 }}
								>
									<div className="w-100 d-flex justify-content-end">
										<div
											style={{ width: 30, height: 30, borderRadius: 50 }}
											className="upper-counter d-flex justify-content-center align-items-center"
										>
											<h4 className="text-white p-0 m-0">
												{questions[stage].id}
											</h4>
										</div>
									</div>

									<MDBProgress>
										<MDBProgressBar
											striped
											animated
											width={((stage + 1) * 100) / 40}
											valuemin={0}
											valuemax={40}
										/>
									</MDBProgress>
								</div>
							</div>
							<div
								className="w-100 d-flex flex-column gap-2"
								style={{ marginTop: 50 }}
							>
								<div className="mbti-title">
									<div className="mbti-title-square">{questions[stage].id}</div>
									<h2 className="mt-4 text-center">
										{questions[stage].question}
									</h2>
								</div>
								<div style={{ marginTop: 50 }}>
									{questions[stage].options.map((option) => (
										<div
											className="mbti-option-container d-flex flex-row justify-content-center align-items-center gap-2 mb-3 pointer"
											key={option.option}
											onClick={() =>
												handleOptionChange(
													questions[stage].id,
													questions[stage].dimension,
													option.value,
												)
											}
										>
											<div
												className={` ${answers[questions[stage].id]?.value === option.value && "selected"} mbti-radio   text-center align-content-center `}
											></div>
											<h5 className="m-0 ">
												{option.option}. {option.text}
											</h5>
										</div>
									))}
								</div>
							</div>
							<div className="w-100 d-flex flex-md-row flex-column justify-content-center justify-content-md-between align-items-center gap-md-0 gap-3 ">
								<button
									className="mbti-nav-btn"
									onClick={() => changeStage("prev")}
									disabled={stage === 0}
									style={{ left: 10 }}
								>
									<ArrowRight
										variant="Linear"
										className="ms-2"
										style={{ marginLeft: 10 }}
									/>{" "}
									قبلی
								</button>
								{stage === 39 ? (
									<button className="mbti-nav-btn" onClick={handleSubmit}>
										ثبت
									</button>
								) : (
									<button
										className="mbti-nav-btn mbti-submit-btn"
										onClick={() => changeStage("next")}
										disabled={stage === 39 || !answers[stage + 1]}
										style={{ left: 10 }}
									>
										بعدی{" "}
										<ArrowLeft
											variant="Linear"
											className="ms-2"
											style={{ marginLeft: 10 }}
										/>
									</button>
								)}
							</div>
						</div>
					</div>
				</>
			) : (
				<>
					<div className="d-flex flex-column w-100 justify-content-start align-items-start">
						{/* MBTI logo and text */}
						<div className="d-flex flex-column justify-content-center align-items-start mb-4">
							<img
								src={mbtiLogo}
								alt="mbti logo"
								style={{ width: 81, height: 150, objectFit: "contain" }}
							/>
						</div>
						<div style={{ flex: 1, textAlign: "right" }}>
							<h1 style={{ fontWeight: 700, fontSize: 28, marginBottom: 0 }}>
								تست MBTI{" "}
								<span style={{ fontWeight: 400, fontSize: 22 }}>
									(مایرز بریگز)
								</span>
							</h1>
							<div
								className="d-flex flex-row align-items-center mt-2"
								style={{ color: "#6B778C", fontSize: 16, fontWeight: 500 }}
							>
								<Clock
									size={20}
									variant="Linear"
									color="#6B778C"
									className="ms-2"
									style={{ marginLeft: 10 }}
								/>
								مدت زمان: ۱۵ دقیقه
							</div>
						</div>

						<hr style={{ width: "336px", borderTop: "1px solid #6B778C" }} />
						<div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
							<p
								style={{
									color: "#6B778C",
									fontSize: 20,
									fontWeight: 500,
									textAlign: "right",
									margin: "0 auto 32px auto",
								}}
							>
								این تست دارای ۶۰ سوال است. در پاسخ به سوالات گزینه ای را انتخاب
								کنید که به شخصیت واقعی شما نزدیک تر است نه ویژگی هایی که می
								خواهید داشته باشید. پاسخ درست یا غلط وجود ندارد. به تمامی سوالات
								با دقت پاسخ دهید.
							</p>
							<MDBBtn
								style={{
									background: "#0052CC",
									color: "#fff",
									fontWeight: 700,
									fontSize: 22,
									borderRadius: 10,
									minWidth: 194,
									maxWidth: 194,
									boxShadow: "0 4px 0 #1C1C1E",
									margin: "0 auto",
								}}
								onClick={() => setStage(0)}
							>
								شروع تست!
							</MDBBtn>
						</div>
					</div>
				</>
			)}
		</div>
	);
}
export default MBTIForm;
